import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { ProformaService } from '../../../services/operaciones/proforma/proforma.service';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { OperacionService } from '../../../services/operaciones/operacion/operacion.service';
import {FiltrosOperacion} from '../../../models/FiltrosOperacion';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-operacion',
  templateUrl: './listado-operacion.component.html',
  styleUrls: ['./listado-operacion.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoOperacionComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  Label_id_soles=environment.ID_GUIA_SOLES;
  idOperacion: number = 0;
  user:any;

  flagOperacionDetalle:boolean = false;

  fechaD: Date = new Date();
  fechaH: Date = new Date();
  ruc = new FormControl();
  rucAdq = new FormControl();
  id: any;

  operacion: any = [];
  estado ="P";
  idProv ="" ;
  idAdq: any;
  
  pdf : any;
  form : FormGroup;
  proveedoresArr : any;
  adquirentesArr : any;
  filteredProveeedor: Observable<any[]>;
  filteredAdquirentes: Observable<any[]>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  
  pageSizeOptions = [15,20,30,50,100,200];
  
  loading:boolean;
  displayedColumns: string[] = 
    ['checked','Codigo_Orden','Fecha_del_Operacion','pNomComercial','aNomComercial','Moneda','VNPP','Adelanto_porcentaje','Adelanto_importe','Tasa_Mensual','TAI','Remanente_importe','Adelanto_Ejecutado_importe','Adelanto_Pendiente_importe','Adelanto_Vencido_Importe','Estado','Adjunto_PDF']
      
  dataSource :any;
  DTOFiltrosOperacion: FiltrosOperacion = new FiltrosOperacion();
  constructor( 
    private proformaService:ProformaService,
    private operacionService:OperacionService,
    private datePipe :DatePipe,
    private router:Router,
    private loginService:LoginService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.displayedColumns = (this.user.id_roles == 45)? ['Codigo_Orden','Fecha_del_Operacion','pNomComercial','aNomComercial','Moneda','VNPP','Adelanto_porcentaje','Adelanto_importe','Tasa_Mensual','TAI','Remanente_importe','Adelanto_Ejecutado_importe','Adelanto_Pendiente_importe','Adelanto_Vencido_Importe','Estado','Adjunto_PDF']:this.displayedColumns;
    
    this.fechaD.setDate(this.fechaD.getDate()-60);
    this.ObtenerEmpresasCombo();
    this.ObtenerAdquirentesCombo();
   }

  ngOnInit() {
    this.ListadoOperacionFiltros();
  }
 
  ObtenerEmpresasCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));

      this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }
  

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }
  
  obtenerId(termino :string){
    this.id = termino;
    this.DTOFiltrosOperacion.Id = termino;
  }

  blankEstado(){
    this.DTOFiltrosOperacion.Estado = "";
  }

  blankIdOperacion(){
    this.DTOFiltrosOperacion.IdOperacion = "";
  }
  blankCodOperacion(){
    this.DTOFiltrosOperacion.CodOperacion = "";
  }

  EnterobtenerRucRazSocialProv(termino :string = ''){
    
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.proveedoresArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            this.DTOFiltrosOperacion.Id = p.idEmpresa;
          }  
      }
    }
  }
  obtenerIdAd(terminoAD :string){
    this.idAdq = terminoAD;
    this.DTOFiltrosOperacion.IdAd = terminoAD;
  }

  obtenerAdRazSocial(terminoAD :string = ''){    
    if (terminoAD != null && terminoAD != ''){
      let terminoAD1 = terminoAD.toLowerCase();                 
      for( let a of this.adquirentesArr){  
          let raz = a.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoAD1)  >= 0){    
            this.idAdq = a.idEmpresa;
            this.DTOFiltrosOperacion.IdAd = a.idEmpresa;
          }
      }
    }
    }
  
    ObtenerAdquirentesCombo() {
      this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));   
      this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAd(state) : this.adquirentesArr.slice()
        )
      );
   
  }

  private _filterAd(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }
  
  obtenerpdf($file:any){
    window.open($file,"_blank");
  }

  ListadoOperacionFiltros() {
    this.loading = true;

    let desde = this.datePipe.transform(this.fechaD,'yyyy-MM-dd');
    let hasta = this.datePipe.transform(this.fechaH,'yyyy-MM-dd');

    if (this.ruc.value == null || this.ruc.value == ""){
      this.id = "";
      this.DTOFiltrosOperacion.Id = ""
    }

    if (this.rucAdq.value == null || this.rucAdq.value == ""){
      this.idAdq="";
      this.DTOFiltrosOperacion.IdAd="";
    }
    if (this.DTOFiltrosOperacion.IdOperacion.length > 0){
      this.DTOFiltrosOperacion.Id = ""
      this.DTOFiltrosOperacion.IdAd = "" 
      desde = "1990-01-01";
      hasta = this.datePipe.transform(new Date(),'yyyy-MM-dd');
    }
    if (this.DTOFiltrosOperacion.CodOperacion != ''){
      this.DTOFiltrosOperacion.Id = ""
      this.DTOFiltrosOperacion.IdAd = ""
      this.DTOFiltrosOperacion.IdOperacion = ""
      desde = "1990-01-01";
      hasta = this.datePipe.transform(new Date(),'yyyy-MM-dd');
    } 
    
    this.operacionService.FiltroListadoOperacion(this.DTOFiltrosOperacion,desde,hasta).subscribe( 
      res => {
        this.operacion = res;      
        this.dataSource = new MatTableDataSource( this.operacion);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      },err =>{
          Swal.fire({
            title: "¡Algo salió mal!",
            text:  err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });        
          this.loading = false;
      }
    )
  }

  cargarListadoCompleto(){
    this.loading = true;
    this.operacionService.FiltroListadoOperacion(this.DTOFiltrosOperacion,this.datePipe.transform(this.fechaD,'dd-MM-yyyy'),this.datePipe.transform(this.fechaH,'yyyy-MM-dd'))
    .subscribe(res=>{
      this.operacion = res;
      this.loading = false;

      this.dataSource = new MatTableDataSource(this.operacion);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  verOperacion(id:string){
    this.loginService.clickGuard = true;
    this.router.navigate(['/operaciones/operacion/Visualizar/',id]);
  }

  enviarIdOperacion(idOperacion:any){
    this.idOperacion = idOperacion;
    this.flagOperacionDetalle = true; 
  }

  MetcerrarOperacionDetalle(){
    this.flagOperacionDetalle   = false;
  }
  
  darBajaOperacion(idOperacion,idProforma){
    Swal.fire({
      title:'',
      text:'¿Estás seguro en dar de baja esta Operación?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText:'Si, dar de baja.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result)=>{
      if(result.value){
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        })
        Swal.showLoading();
        this.form = new FormGroup({
          'idOperacion' : new FormControl(idOperacion),
          'Estado' : new FormControl('B'),
          'Baja_Canal': new FormControl('W'),
          'Baja_Usuario': new FormControl(this.user.Usuario) 
        })
        this.operacionService.BajaOperacion(this.form.getRawValue())
        .subscribe(res=>{
          this.actualizarProforma(idProforma);
          Swal.fire({
            title: 'Operación dado de baja!',
            text: "La operación Nro "+idOperacion+" fue dado de baja exitosamente.",
            type: 'success',
            heightAuto: false
          }).then(resp => {
            if(resp.value == true){
              this.ListadoOperacionFiltros();
            }
          });
        },
        err => {
          Swal.fire({
            title: "Error",
            text: "No se pudo dar de baja la Operación.",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        })
      }
    })
  }

  actualizarProforma(idProforma){
    let body : any = {"idProforma":idProforma, "Estado" : "R"}
      this.proformaService.actualizarProforma(body).subscribe(
        res => {
          this.showNotification('success','top','right',this.Label_Proforma+' Nro. '+idProforma+' liberada.');
        },err => {
          let error = "";
          error = err.error.error;
          this.showNotification('warning','top','right','No se pudo actualizar la '+this.Label_Proforma+'  Nro.'+idProforma+'\n Error: ' + error);
        });
  }
  

 showNotification(type,from,align,message){
      $.notify({
      icon: "notifications",
      message: message
  },{
      type: type,
      timer: 4000,
      placement: {
          from: from,
          align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
  });
}

}
